import { throwGenericError } from '../../error';
import { objectMapping } from '../../api/common';
import { setTrygTealium } from '../../tracking';

export const POSTAL_CODE = 'postalCode';

/**
 * Actions to be connected from redux userData.
 * @type {Object}
 */
export const actionsToConnect = {};

/**
 * Values to be connected from redux userData.
 * @type {Array}
 */
export const propsToConnect = state => state;

/**
 * Sets a suggestion in the form.
 * @param  {Object}   suggestion Object representing a suggestion.
 * @param  {Function} setValues  Set value function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 */
const setFormValues = (suggestion, setValues, values) => {
  const payload = {
    ...values,
    postalCode: suggestion.nr,
    postalCodeInput: suggestion.nr,
    city: suggestion.navn,
  };

  if (values.postalCode !== suggestion.nr) {
    payload.street = null;
    payload.houseNumber = null;
    payload.addressInput = null;
    payload.floorNumber = null;
    payload.unitNumber = null;
  }
  const trackingData = {
    customer_address_zipcode: payload.postalCode,
  };
  setTrygTealium(trackingData);

  setValues(payload);
  objectMapping(values, payload);
};

/**
 * Clears the form.
 * @param  {Function} setValues  Set value function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 */
const clearFormValues = (setValues, values) => {
  const payload = {
    ...values,
    postalCode: null,
    postalCodeInput: null,
    city: null,
  };
  setValues(payload);
};

/**
 * Function that fetches the value to render.
 * @param  {Object} values The current Formik values.
 * @param  {Object} that   This object from caller.
 * @return {string}        The value to show.
 */
export const getValue = (values, that) => {
  return values.postalCode ? decodeURIComponent(`${values.postalCode} - ${values.city}`) : that.state.value;
};

/**
 * How a suggestion looks when selected.
 * @param  {Object}   suggestion Object representing a suggestion.
 * @param  {Function} setValues  Set values function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 * @return {string}              String representation of the suggestion.
 */
export const getSuggestionValue = (suggestion, setValues, values) => {
  setFormValues(suggestion, setValues, values);
  return `${suggestion.nr} - ${suggestion.navn}`;
};

/**
 * How should the suggestions be rendered in the list.
 * @param  {Object} suggestion Object representing a suggestion.
 * @return {string}            String representation of the suggestion.
 */

export const renderSuggestion = suggestion => {
  return `${suggestion.nr} - ${suggestion.navn}`;
};

/**
 * Event to be called on change.
 * @param  {InputEvent} event     The event.
 * @param  {string}     newValue  The current value of the input field.
 * @param  {Object}     that      The "this" object of the caller.
 */
export const onChangeEvent = (event, newValue, that) => {
  that.setState({
    isTyping: true,
    value: newValue,
  });
};

/**
 * Event to call onBlur.
 * @param  {Object}   that      The "this" object of the caller.
 * @param  {Object}   suggestion The suggestion.
 * @param  {Function} setValues  The set values function of the Formik component.
 * @param  {Object}   values     The current values of the Formik componenet.
 */
export const onBlurEvent = (that, suggestion, setValues, values) => {
  if (!suggestion) {
    return;
  }
  setFormValues(suggestion, setValues, values);
  that.setState({ value: suggestion.nr });
};

/**
 * onSuggestionsFetchRequested is called whenever new suggestions should be fetched.
 * @param  {string}   value      The value entered into the input field.
 * @param  {Object}   that       The "this" object of the caller.
 * @param  {Function} dispatch   The dispatch function of the store.
 * @param  {Function} setValues  Set values function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 */
export const onSuggestionsFetchRequested = (value, that, dispatch, setValues, values) => {
  if (value.length === 0) {
    clearFormValues(setValues, values);
    that.setState({
      suggestions: [],
    });
  }
  that.setState({
    isLoading: true,
  });
  const initialValuesData = that.props.autoProps.section.packageData.initialValues.postnummer || []
  // based on postnumber or city filtering out from intial list
  const autoSuggestions = initialValuesData.filter((r) => {
    return (
      r.nr.includes(value || '') ||
      r.navn.toLowerCase().includes((value || '').toLowerCase()) ||
      `${r.nr}-${r.navn}`.toLowerCase().replace(/\s+/g, '').includes(((value || '').toLowerCase()).replace(/\s+/g, ''))
    );
  }) || [];

  that.setState({
    suggestions: autoSuggestions,
    isLoading: false,
  });
  if (autoSuggestions.length === 1) {
    const suggestion = autoSuggestions[0];
    setFormValues(suggestion, setValues, values);
  } else if (autoSuggestions.length === 0) {
    clearFormValues(setValues, values);
  }
};

/**
 * onSuggestionsClearRequested is called whenever the suggestions should be cleared.
 * @param  {Object} that  The "this" object of the caller.
 * @param  {Function} setValues  Set values function of the Formik component.
 * @param  {Array}    values     The current Formik values.
 */
export const onSuggestionsClearRequested = (that, setValues, values) => {
  if (that.state.value.length === 0) {
    clearFormValues(setValues, values);
  }
  that.setState({
    suggestions: [],
  });
};

export const type = POSTAL_CODE;



// WEBPACK FOOTER //
// ./src/utilities/form/autoSuggest/postalCode.js